<template>
  <div class="HomeContainer">
    <div class="detailContainer" v-if="detail" key="detail">
      <div class="headContainer">
        <div>
          <div class="title">
            <img :src="GetResourceUrl('flags/' + detail.country.toLowerCase() + '.png')"
              style="width:20px;vertical-align: middle;" />
            <span style="vertical-align: middle;margin-left:6px;">{{ detail.title }}</span>

            <!-- <span class="purchase_count">
              <el-image
                :src="GetResourceUrl('home/icon-purchase_count.svg')"
              ></el-image>
              <div v-if="detail.auth_count" class="color-warning">
                <span style="font-size: 15px; margin-right: 2px">{{
                  detail.auth_count
                }}</span
                >{{ l("家已报价") }}
              </div>
              <div v-else style="font-weight: normal">{{ l("暂无报价") }}</div>
            </span> -->
          </div>
          <div class="created_time">
            {{ l("发布时间") }}：{{ $utils.i18nDate(detail.created_time) }}

            <!-- <i class="el-icon-view" style="margin: 0 5px 0 20px"></i
            >{{ detail.browse_count }} -->
          </div>
          <div class="collection_contact">
            <div v-if="detail.is_collect" class="collect" @click="collect">
              <el-image :src="GetResourceUrl('home/icon-collection_1.svg')"></el-image>
              {{ l("已收藏") }}
            </div>
            <div v-else class="collect" @click="collect">
              <el-image :src="GetResourceUrl('home/icon-collection_0.svg')"></el-image>
              {{ l("加入收藏") }}
            </div>
            <div class="contact" @click="getQuotation">
              {{ l("查看报价") }}
            </div>
            <div class="contact">
              <el-image :src="GetResourceUrl('home/icon-tel.svg')"></el-image>
              <div v-if="detail.mobile">{{ detail.mobile }}</div>
              <div v-else @click="getContact">{{ l("获取号码") }}</div>
            </div>
          </div>
        </div>
        <div>
          <el-image v-if="detail.is_expire" style="width: 81px; height: 76px"
            :src="GetResourceUrl('home/icon-expire.svg')"></el-image>
          <div v-else style="display: flex; flex-direction: column; align-items: center">
            <div class="un_expire">
              {{ l("距离报价结束还剩") }}
              <span>{{ detail.expire_distance }}</span>
              {{ l("天") }}
            </div>
            <el-button type="warning" style="width: 140px; height: 40px; margin-top: 5px" @click="doBusiness">{{
              detail.business_action_code ? l("修改我的报价") : l("我要报价")
            }}</el-button>
          </div>
        </div>
      </div>
      <div class="materialInfo">
        <div class="title">{{ l("基本信息") }}</div>
        <div class="amount">
          {{ l("需求") }}
          <span>
            {{ detail.specification_amount[0].amount }}
          </span>
          {{ l(detail.specification_amount[0].unit) }}
        </div>
        <div class="tableContainer">
          <div v-if="detail.quality_type == 1" class="column">
            <div class="header">{{ l("品类 品名") }}</div>
            <div class="content">
              {{ l($store.getters.getCategory(detail.category_id)) }}
              {{ l(detail.child_category) }}
            </div>
          </div>
          <div class="column">
            <div class="header">{{ l("材料") }}</div>
            <div class="content">{{ detail.material }}</div>
          </div>
          <template v-if="detail.quality_type == 1 || detail.quality_type == 2">
            <div class="column">
              <div class="header">{{ l("规格") }}</div>
              <div class="content">
                {{ detail.specification_amount[0].specification }}
              </div>
            </div>
            <div class="column">
              <div class="header">{{ l("钢厂") }}</div>
              <div class="content">{{ detail.steel_mill }}</div>
            </div>
          </template>

          <template v-if="detail.quality_type == 3">
            <div class="column">
              <div class="header">{{ l("类型") }}</div>
              <div class="content">
                {{
                  $utils.listFilter(
                    $store.state.basicInfo.forge_typeList,
                    detail.forge_type
                  )
                }}
              </div>
            </div>
            <div class="column">
              <div class="header">{{ l("交货状态") }}</div>
              <div class="content">
                {{ detail.extra_params.extra_deliver_status || "-" }}
              </div>
            </div>
            <!-- <div class="column">
              <div class="header">工艺等级</div>
              <div class="content">
                {{ detail.extra_params.extra_technique || "-" }}
              </div>
            </div> -->
            <div class="column">
              <div class="header">{{ l("探伤") }}</div>
              <div class="content">
                {{ detail.extra_params.extra_flaw_detect || "-" }}
              </div>
            </div>
            <div class="column">
              <div class="header">{{ l("热处理") }}</div>
              <div class="content">
                {{ detail.extra_params.extra_heat_treatment || "-" }}
              </div>
            </div>
            <div class="column">
              <div class="header">{{ l("光洁度") }}</div>
              <div class="content">
                {{ detail.extra_params.extra_surface_grade || "-" }}
              </div>
            </div>
            <div class="column">
              <div class="header">{{ l("硬度") }}</div>
              <div class="content">
                {{ detail.extra_params.extra_hard || "-" }}
              </div>
            </div>
          </template>

          <template v-if="detail.quality_type == 4">
            <div class="column">
              <div class="header">{{ l("类型") }}</div>
              <div class="content">
                {{
                  $utils.listFilter(
                    $store.state.basicInfo.machining_typeList,
                    detail.machining_type
                  )
                }}
              </div>
            </div>
            <div class="column">
              <div class="header">{{ l("交货状态") }}</div>
              <div class="content">
                {{ detail.extra_params.extra_deliver_status || "-" }}
              </div>
            </div>
          </template>
        </div>
      </div>
      <div v-if="detail.img_array.length || detail.pdf" class="img_arrayContainer">
        <div>{{ l("附件") }}</div>
        <el-image v-for="(item, index) of detail.img_array" :key="index" :src="item" fit="cover"
          :preview-src-list="detail.img_array"></el-image>
        <div v-if="detail.pdf" class="pdfContainer">
          <el-image :src="GetResourceUrl('PDF.png')" fit="contain"></el-image>
          <div class="pdfCover" @click="goPDF">
            <i class="el-icon-download"></i>
            <div>点击查看</div>
          </div>
        </div>
      </div>
      <div class="otherInfo">
        <div class="title">{{ l("其他要求") }}</div>
        <div class="infoLines">
          <div class="line">
            {{ l("计重方式") }}：
            {{
              $utils.listFilter(
                $store.state.basicInfo.weight_methodList,
                detail.weight_method
              )
            }}
          </div>

          <div v-if="detail.quality_type == 1 || detail.quality_type == 2" class="line">
            {{ l("需要质保书") }}：{{
              detail.have_warranty ? l("是") : l("否")
            }}
          </div>

          <div v-if="detail.quality_type == 3 || detail.quality_type == 4" class="line">
            {{ l("需要出具报告") }}：{{
              detail.have_report ? l("是") : l("否")
            }}
          </div>

          <div class="line">
            {{ l("收货地") }}：
            {{ detail.address }}
          </div>
          <div class="line">
            {{ l("截止日期") }}：
            {{ detail.expire_time.slice(0, 10) }}
          </div>
        </div>
      </div>

      <div v-if="detail.description" class="descriptionContainer">
        <div class="title">{{ l("补充说明") }}</div>
        <div class="description" v-html="detail.description"></div>
      </div>
    </div>
    <div v-if="showEmpty" class="emptyContainer" key="empty">
      <el-empty>
        <div slot="description">{{ l("抱歉，该需求不存在或已下架。") }}</div>
      </el-empty>
    </div>
    <BusinessDialog ref="businessDialog" :business_detail="detail" @submitDialog="businessCallback" />
    <el-dialog :title="l('报价记录')" :visible.sync="businessDialogVisible" :destroy-on-close="true" width="1200px">
      <BusinessList v-if="businessDialogVisible" :code="detail.code" :title="detail.title" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="businessDialogVisible = false">{{
          l("取 消")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import BusinessDialog from "@/components/common/BusinessDialog";
import BusinessList from "./BusinessList.vue";

export default {
  name: "HomePurchaseDetail",
  components: { BusinessDialog, BusinessList },
  data() {
    return {
      detail: null,
      imgIndex: 0,
      showEmpty: false,
      businessDialogVisible: false
    };
  },
  created() {
    this.getPurchaseDetail();
  },
  methods: {
    getPurchaseDetail() {
      this.axios
        .get(`/api/visitor_purchase/${this.$route.params.code}/`)
        .then((data) => {
          data.img_array = JSON.parse(data.img_array);
          var date1 = new Date(
            ...this.$utils.formatDate(new Date()).split("-")
          );
          var date2 = new Date(...data.expire_time.slice(0, 10).split("-"));
          data.expire_distance = Math.max(
            0,
            parseInt(date2.getTime() - date1.getTime()) / (1000 * 60 * 60 * 24)
          );
          this.detail = data;
        })
        .catch(() => {
          this.showEmpty = true;
        });
    },
    collect() {
      if (this.detail.is_collect) {
        //axios delete的body需要包装在data内
        this.axios
          .delete(`/api/user_collection/cancel/`, {
            data: {
              code: this.detail.code,
            },
          })
          .then(() => {
            this.detail.is_collect = false;
          });
      } else {
        this.axios
          .post(`/api/user_collection/`, {
            code: this.detail.code,
            module: "purchase",
          })
          .then(() => {
            this.detail.is_collect = true;
          });
      }
    },
    doBusiness() {
      this.$refs.businessDialog.Show({
        module: "purchase",
      });
    },
    businessCallback(formData) {
      if (formData.code) {
        this.axios
          .put(`/api/business_action/${formData.code}/`, formData)
          .then(() => {
            this.$alert(
              this.$store.state.session.user.member_quotation_level ? this.l("请耐心等待采购商接受报价，或直接电联采购商") : this.l("请耐心等待采购商接受报价，专属业务员联系您洽谈合作。")
              , this.l("报价已提交")
              ,{
                confirmButtonText: this.l("知道了"),
                center: true,
              }
            );
          });
      } else {
        this.axios.post(`/api/business_action/`, formData).then((res) => {
          this.detail.business_action_code = res.code; //更新business_action_code
          this.$alert(
            this.$store.state.session.user.member_quotation_level ? this.l("请耐心等待采购商接受报价，或直接电联采购商") : this.l("请耐心等待采购商接受报价，专属业务员联系您洽谈合作。")
            , this.l("报价已提交")
            ,{
              confirmButtonText: this.l("知道了"),
              center: true,
            }
          );
        });
      }


    },
    getQuotation() {
      if (this.$store.state.session.user.id && this.$store.state.session.user.id == this.detail.create_user_id) {
        this.businessDialogVisible = true;
      } else {
        this.$alert(this.l("为保障订单信息安全与发布者权益，系统仅允许订单创建者查看报价内容"), {
          confirmButtonText: this.l("知道了"),
          center: true,
        });
      }
    },
    getContact() {
      this.axios
        .get(`/api/account/get_contact/`, {
          params: {
            module: "purchase",
            code: this.detail.code,
          },
        })
        .then((data) => {
          if (data == 1 || data == 2) {
            this.$alert(this.l("或耐心等待采购商接受报价,专属业务员联系您洽谈合作"), this.l("请联系专属业务员开通获取权限"), {
              confirmButtonText: this.l("前往联系"),
              center: true,
              callback: (res) => {
                if (res == "confirm") {
                  this.$router.push({ path: "/backend/dashboard" });
                }
              },
            });
          } else {
            this.getPurchaseDetail();
          }
        });

    },
    goPDF() {
      window.open(this.detail.pdf, "_blank");
    }
  },
};
</script>


<style scoped lang="scss">
.detailContainer {
  padding: 35px 30px 50px;
  background-color: #fff;
  margin-top: 15px;

  .headContainer {
    display: flex;
    justify-content: space-between;
    padding-bottom: 40px;
    border-bottom: 1px solid $borderPlainColor;

    .title {
      font-size: 18px;
      font-weight: bold;
      width: 900px;

      .purchase_count {
        font-size: 13px;
        color: $warningColor;
        display: inline-flex;
        align-items: center;
        margin-left: 12px;

        .el-image {
          width: 19px;
          height: 17px;
          margin-right: 5px;
        }
      }
    }

    .created_time {
      color: #999;
      margin-top: 10px;
    }

    .collection_contact {
      display: flex;
      margin-top: 10px;

      .collect,
      .contact {
        display: flex;
        align-items: center;
        cursor: pointer;

        .el-image {
          width: 16px;
          height: 16px;
          margin-right: 5px;
        }
      }

      .collect {
        color: #666;
      }

      .contact {
        margin-left: 15px;
        color: $linkColor;
      }
    }

    .un_expire {
      position: relative;
      top: -15px;

      span {
        color: $warningColor;
        font-size: 30px;
        margin: 0 10px;
      }
    }
  }
}

.materialInfo {
  .title {
    padding-left: 8px;
    border-left: 2px solid $warningColor;
    line-height: 14px;
    height: 14px;
    margin-top: 30px;
    font-weight: bold;
  }

  .amount {
    margin-top: 20px;

    span {
      font-size: 30px;
      color: $warningColor;
    }
  }

  .tableContainer {
    margin-top: 30px;
    display: flex;
    box-sizing: border-box;
    border: 1px solid $borderPlainColor;

    .column {
      width: 25%;
      flex-grow: 1;

      .header {
        padding: 12px 0 12px 25px;
        background: $borderPlainColor;
      }

      .content {
        padding: 16px 0 16px 25px;
      }
    }
  }
}

.img_arrayContainer {
  margin-top: 35px;
  color: #666;
  display: flex;

  .el-image {
    width: 74px;
    height: 74px;
    margin-left: 15px;
  }

  .pdfContainer {
    display: inline-block;
    position: relative;
    cursor: pointer;

    &:hover {
      .pdfCover {
        display: flex;
      }
    }

    .pdfCover {
      display: none;
      width: 74px;
      height: 74px;
      position: absolute;
      left: 15px;
      top: 0;
      text-align: center;
      color: #fff;
      background: rgba(0, 0, 0, 0.7);
      flex-direction: column;
      justify-content: center;

      i {
        font-size: 30px;
      }

      div {
        font-size: 10px;
        margin-top: 5px;
      }
    }
  }
}

.otherInfo {
  .title {
    padding-left: 8px;
    border-left: 2px solid $warningColor;
    line-height: 14px;
    height: 14px;
    margin-top: 45px;
    font-weight: bold;
  }

  .infoLines {
    margin: 30px 0;

    .line {
      display: flex;
      margin-top: 10px;
    }
  }
}

.descriptionContainer {
  border-top: 1px solid $borderPlainColor;
  box-sizing: border-box;

  .title {
    line-height: 14px;
    height: 14px;
    margin-top: 30px;
    font-weight: bold;
  }

  .description {
    margin-top: 20px;
    width: 100%;
    white-space: pre-line;
  }
}

.emptyContainer {
  background: #fff;
  margin-top: 15px;
  box-sizing: border-box;
  padding: 100px 0 120px;
}
</style>
